<template>
  <v-card>
    <v-card-text>
      <h3>Dynamic Viscosity</h3>
      <convert-box></convert-box>
    </v-card-text>
  </v-card>
</template>

<script>
import ConvertBox from '../components/ConvertBox'

export default {
  components: { ConvertBox },
  data() {
    return {
      unit: [
        {
          text: 'Centipoise (cP)',
          val: 1
        },
        {
          text: 'Gram per centimeter second (g/(cm·s))',
          val: 0.01
        },
        {
          text: 'Kilogram per metre second (kg/(m·s))',
          val: 0.001
        },
        {
          text: 'Newton second per square metre (N·s/m²)',
          val: 0.001
        },
        {
          text: 'Pascal-second (Pa·s)',
          val: 0.001
        },
        {
          text: 'Poise (P)',
          val: 0.01
        },
        {
          text: 'Pound-force second per square inch (lbf·s/in²)',
          val: 1.45037737797e-7
        },
        {
          text: 'Pound-force second per square foot (lbf·s/ft²)',
          val: 0.0000208854342332
        },
        {
          text: 'Pound per foot second (lb/(ft·s))',
          val: 0.00067196897514
        },
        {
          text: 'Pound per foot hour (lb/(ft·h))',
          val: 2.419088310502
        },
        {
          text: 'Slug per foot second (slug/(ft·s))',
          val: 0.0000208854342332
        },
        {
          text: 'Poundal second per square foot',
          val: 0.0001019716212978
        },
        {
          text: 'Dyne second per square centimetre (dyn·s/cm²)',
          val: 0.01
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('setUnit', this.unit)
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// dynamic-viscosity.vue?526f4d04